const about = {
  title: "So funktioniert’s",
  contentSection: {
    title: "Zunächst bietet iizenglish:",
    paragraphs: [
      [
        "Interaktive und selbstkorrigierende Übungen (Grammatik, Wortschatz, Hörverstehen und Ausdrucksfähigkeit sowie Quizze zur anglophonen Kultur) auf den Niveaus A1, A2, B1 und B2 des GER.",
        "Übungstests für Ev@lang und Englisch-Zertifizierungen.",
        "Die Vielfalt der angebotenen Aktivitäten und Materialien hilft jedem Lernenden, sich eingebunden zu fühlen und dadurch aktiv an seinem Lernprozess teilzunehmen.",
        "Kursmaterialien (zum Ausdrucken oder Downloaden).",
        "1.300 Zeichnungen (erstellt von Bod’Z, Illustrator).",
        "2.000 Audioaufnahmen.",
      ],
      "Unsere Übungen basieren auf reichhaltigen kulturellen Inhalten, insbesondere durch zahlreiche Texte und Audios mit Bezug zur anglophonen Welt und zu aktuellen Themen: Alltag (Essen, Schulsystem, Freizeit, Sport, mein Zuhause, mein Viertel), kulturelle Besonderheiten (Persönlichkeiten aus der anglophonen Welt, Gap Year) sowie aktuelle Themen (Umwelt, Fast Fashion, Überkonsum, Gaming, Generation Z, soziale Medien, Olympische Spiele).",
    ],
  },
  forWhoSection: {
    title: "Für wen?",
    paragraphs: [
      "Die Website iizenglish kann sowohl individuell genutzt werden als auch als unterstützendes Tool für Lehrkräfte innerhalb ihrer Klassen dienen.",
    ],
  },
  HowDoesItWorkSection: {
    title: "Wie funktioniert die Website iizenglish?",
    forIndividuals: {
      title: "FÜR SCHÜLER/INNEN ODER PRIVATNUTZER/INNEN:",
      paragraphs: [
        "1. Sie registrieren sich ganz einfach als Schüler/in, indem Sie Ihren Vor- und Nachnamen, Ihre E-Mail-Adresse sowie ein von Ihnen festgelegtes Passwort eingeben.",
        "2. Anschließend haben Sie Zugriff auf die Übersichten zu Grammatik und Wortschatz sowie auf einige frei zugängliche Übungen, mit denen Sie trainieren können.",
        "3. Um Zugriff auf alle Übungen und die dazugehörigen Lernmaterialien zu erhalten, müssen Sie ein Jahresabonnement abschließen.",
        "4. Nach der Online-Zahlung erhalten Sie unbegrenzten Zugang zur Website iizenglish sowie zu allen zukünftigen Updates.",
      ],
    },
    forTeachers: {
      title: "FÜR LEHRKRÄFTE:",
      paragraphs: [
        "1. Sie registrieren sich als Lehrkraft, indem Sie Ihren Vor- und Nachnamen, Ihre E-Mail-Adresse sowie ein von Ihnen festgelegtes Passwort eingeben.",
        "2. Anschließend erhalten Sie Zugriff auf das Lehrkräfte-Dashboard.",
        "3. Anschließend erstellen Sie Ihre Klasse, indem Sie die Vor- und Nachnamen sowie die E-Mail-Adressen Ihrer Schülerinnen und Schüler eingeben. Diese erhalten daraufhin eine E-Mail mit der Aufforderung, sich auf der Website iizenglish anzumelden und ihren jährlichen Beitrag zu bezahlen.",
        "4. Sobald mindestens 10 Schülerinnen und Schüler ein Abonnement abgeschlossen haben, erhalten Sie für die Dauer eines Jahres Zugriff auf den gesamten Grammatik- und Wortschatzüberblick sowie auf die dazugehörigen Lernmaterialien und können Aufgaben für den Unterricht oder für zu Hause für Ihre Klasse erstellen.",
        "5. Das Abonnement für Lehrkräfte ist kostenlos.",
      ],
    },
    forStudentsAttachedToTeacher: {
      title:
        "FÜR SCHÜLERINNEN UND SCHÜLER, DIE EINER LEHRKRAFT ZUGEORDNET SIND:",
      paragraphs: [
        "1. Sie erhalten eine E-Mail mit der Aufforderung, sich auf der Website iizenglish anzumelden. Sie klicken auf den in der E-Mail enthaltenen Link und erstellen Ihr Passwort oder melden sich mit Ihren Zugangsdaten an, wenn Sie bereits persönlich registriert sind. (Hinweis: Wenn Sie bereits ein Abonnement abgeschlossen haben, werden Sie automatisch Ihrer Lehrkraft zugeordnet, ohne dass weitere Schritte erforderlich sind.)",
        "2. Um die Aufgaben Ihrer Lehrkraft zu erhalten, müssen Sie Ihr Jahresabonnement direkt auf der Website abschließen.",
        "3. Anschließend erhalten Sie die zu erledigenden Aufgaben direkt von Ihrer Lehrkraft. Außerdem haben Sie Zugriff auf alle Übungen und Lernmaterialien, um jederzeit trainieren zu können.",
        "4. Bei der Bearbeitung einer Aufgabe haben Sie so viele Versuche, wie Sie möchten; die Plattform iizenglish stellt Ihnen dabei jedes Mal unterschiedliche Sätze zur Verfügung. Jede Aufgabe ist einzigartig. An Ihre Lehrkraft wird ausschließlich die beste Note aus Ihren verschiedenen Versuchen übermittelt.",
      ],
    },
  },
  AndNowSection: {
    title: "Und jetzt?",
    paragraphs: [
      "Ich bin Schüler/in oder Privatnutzer/in:",
      "Das Abonnement wird direkt über die Website mittels einer sicheren Zahlung abgeschlossen.",
      "Das Abonnement beträgt {price} für die Dauer eines Jahres.",
      "Ich bin Lehrkraft:",
    ],
    links: [
      "Ich erstelle mein Konto und schließe ein Abonnement ab",
      "Ich registriere mich und erstelle meine erste Klasse",
    ],
  },
  bottomSection: {
    title: "WIE KÖNNEN SIE UNS KONTAKTIEREN?",
    paragraphs: [
      "Sie erreichen uns per E-Mail unter: {'contact@iizenglish.com'}",
      "Wenn Sie eine Bildungseinrichtung sind, können wir Sie bei der automatisierten Registrierung Ihrer Lehrkräfte und Schülerinnen und Schüler unterstützen. Zögern Sie nicht, uns zu kontaktieren.",
    ],
  },
};

export default about;
